import { v4 as uuidv4 } from 'uuid'
import { ssoStorage } from './ssoStorage'
import type { SSOClientConfig } from './types'

export function generateOAuthState(clientName: string): string {
  const nonce = uuidv4()
  ssoStorage.setStateNonce(nonce, clientName)
  return `${nonce}:${clientName}`
}

/**
 * Validates the OAuth state nonce and returns the client config that was
 * resolved from the BFF registry at SSO landing time.
 */
export function resolveClientFromOAuthState(state: string | null): SSOClientConfig | undefined {
  if (!state || state === 'popup_auth=true') return undefined
  const separatorIndex = state.indexOf(':')
  if (separatorIndex === -1) {
    ssoStorage.clearStateNonce()
    return undefined
  }

  const nonce = state.substring(0, separatorIndex)
  const clientName = state.substring(separatorIndex + 1)
  const stored = ssoStorage.getOAuthState()

  if (!stored || stored.nonce !== nonce || stored.clientName !== clientName) {
    // Clear even when only one of the nonce/client keys remains, so a
    // partially-cleared localStorage can't leave stale OAuth state behind.
    ssoStorage.clearStateNonce()
    return undefined
  }

  ssoStorage.clearStateNonce()
  const resolvedConfig = ssoStorage.getContext()?.resolvedConfig
  return resolvedConfig?.clientName === clientName ? resolvedConfig : undefined
}
